export default {"src":"/_next/static/media/filters-black.b488c1f0.svg","height":15,"width":24,"blurWidth":0,"blurHeight":0};